import { createSlice } from '@reduxjs/toolkit';

const booleanSlice = createSlice({
  name: 'boolean',
  initialState: {
    isActive: false,
  },
  reducers: {
    toggleIsActive: (state) => {
      state.isActive = !state.isActive;
    },
    setIsActive: (state, action) => {
      state.isActive = action.payload;
    },
  },
});

export const { toggleIsActive, setIsActive } = booleanSlice.actions;
export default booleanSlice.reducer;
